export default [
    { title: "Use Cloud Secure endpoint rather than preview link for Cloud Secure in LaunchPad", key: "cloudSecureLink" },
    { title: "Query Cloud Volumes Service aws to determine if user is registered", key: "cloudVolumesRegisteredQuery" },
    { title: "Federation Setup", key: "federationSetup" },
    { title: "Timeline", key: "timeline"}
];
